
export function createDemogKey(prop) {
  let keyName = prop["title"].toLowerCase().replace(/[^a-zA-Z0-9]/g, ""); //remove special characters
  keyName = keyName.replace(" ", "_"); //replace spaces to underscore
  keyName = `${prop["user".toLowerCase()]}_${keyName}`;

  return keyName;
};

export function hasOnlyDigits(value) {
  return /^-{0,1}\d+$/.test(value);
};


// WEBPACK FOOTER //
// ./src/views/callform/utils.js